"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _NavigateBackButton = require("@ccw-pwa-ui/NavigateBackButton");
var _Modal = require("@ccw-pwa-ui/Modal");
var _Input = require("@ccw-pwa-ui/Input");
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
require("../styles/CurrentChangePasswordComponentStyles.css");
var _reactBootstrap = require("react-bootstrap");
var _bs = require("react-icons/bs");
var _index = _interopRequireDefault(require("../common_features/assets/images/index"));
var _Button = require("@ccw-pwa-ui/Button");
const CurrentChangePasswordComponent = props => {
  var _props$displayModalDa, _props$displayModalDa2, _props$displayModalDa3, _props$displayModalDa4, _props$displayModalDa5, _props$displayModalDa6, _props$displayModalDa7, _props$displayModalDa8, _props$displayModalDa9, _props$displayModalDa10, _props$displayModalDa11;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "force-change-password-screen"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "back-navigation"
  }, /*#__PURE__*/_react.default.createElement(_NavigateBackButton.NavigateBackButton, {
    navHeading: props.backNavigationScreen,
    handleBack: props.handleBack,
    leftArrowImage: _index.default.leftArrow.default
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, {
    style: {
      maxWidth: 480,
      marginTop: '20px'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "change-password-input-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "notification-screen-title"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "link-text",
    headerText: props.headerText
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "enter-password-container ".concat(props.currentPassword && props.currentPasswordError ? "P-error" : "")
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333'
    },
    variant: "header-text",
    headerText: props.confirmPasswordText
  }), /*#__PURE__*/_react.default.createElement(_Input.Input, {
    inputStyle: {
      borderRadius: 10,
      marginTop: "20px"
    },
    placeholder: props.currentPasswordPlaceholder,
    inputType: "password",
    value: props.currentPassword,
    onchange: props.onChangeCurrentPassword
  }), props.currentPasswordError && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      color: "red"
    }
  }, "Please enter a correct password"), props.currentPasswordError && /*#__PURE__*/_react.default.createElement("img", {
    src: _index.default.warning.default,
    alt: "",
    className: "input-current-password-warningIcon2"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "enter-new-password-container ".concat(props.errorMessage && props.isNewPasswordTouch ? "P-error" : ""),
    style: {
      position: "relative"
    },
    "data-testid": "enter-new-password-container"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333',
      marginBottom: "20px"
    },
    variant: "header-text",
    headerText: props.passwordText
  }), /*#__PURE__*/_react.default.createElement(_Input.Input, {
    inputStyle: {
      borderRadius: 10,
      marginTop: "20px"
    },
    placeholder: props.newPasswordPlaceholderCCP,
    inputType: "password",
    value: props.newpasswordCCP,
    onchange: props.onChangeNewPasswordCCP,
    onBlur: props.handleNewPasswordBlur
  }), props.errorMessage && props.isNewPasswordTouch && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      color: "red"
    }
  }, "Password doesn't meet requirement"), props.errorMessage && props.isNewPasswordTouch && /*#__PURE__*/_react.default.createElement("img", {
    src: _index.default.warning.default,
    alt: "",
    className: "input-current-password-warningIcon"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "change-password-validation"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_bs.BsCheck, {
    style: {
      fontSize: 15,
      color: props.hasMinLengthCCP
    }
  }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400
    },
    variant: "simple-text",
    headerText: props.validationTextt1
  })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_bs.BsCheck, {
    style: {
      fontSize: 15,
      color: props.hasOneUpperLowerCase
    }
  }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400
    },
    variant: "simple-text",
    headerText: props.validationTextt2
  })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_bs.BsCheck, {
    style: {
      fontSize: 15,
      color: props.hasOneNumber
    }
  }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400
    },
    variant: "simple-text",
    headerText: props.validationTextt3
  })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_bs.BsCheck, {
    style: {
      fontSize: 15,
      color: props.hasSpecialChar
    }
  }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400
    },
    variant: "simple-text",
    headerText: props.validationTextt4
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "change-password-confirm-input-wrapper ".concat(props.conFirmErrorMessage ? "p2-error" : "")
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333'
    },
    variant: "header-text",
    headerText: props.confirmPassword
  }), /*#__PURE__*/_react.default.createElement(_Input.Input, {
    inputStyle: {
      borderRadius: 10,
      marginTop: "20px"
    },
    placeholder: props.confirmPasswordPlaceholder,
    inputType: "password",
    value: props.confirmNewPassword,
    onchange: props.onChangeConfirmNewPassword
  }), props.conFirmErrorMessage && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      color: "red"
    }
  }, "Password do not match"), props.conFirmErrorMessage && /*#__PURE__*/_react.default.createElement("img", {
    src: _index.default.warning.default,
    alt: "",
    className: "input-current-password-warningIcon2"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "Change-password-button-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "change-password-button-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "primary-long",
    title: props.buttonText,
    onClick: props.onClickContinue,
    disabled: !props.isContinueDisabled
  }))))), props.isLoading ? /*#__PURE__*/_react.default.createElement("div", {
    className: "spinner-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Spinner, {
    animation: "border"
  })) : null, props.displayModal && /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    displayModal: props.displayModal,
    variant: (_props$displayModalDa = props.displayModalData) === null || _props$displayModalDa === void 0 ? void 0 : _props$displayModalDa.variant,
    displayCrossIcon: (_props$displayModalDa2 = props.displayModalData) === null || _props$displayModalDa2 === void 0 ? void 0 : _props$displayModalDa2.displayCrossIcon,
    modalHeaderText: (_props$displayModalDa3 = props.displayModalData) === null || _props$displayModalDa3 === void 0 ? void 0 : _props$displayModalDa3.modalHeaderText,
    modalHeaderTextStyle: (_props$displayModalDa4 = props.displayModalData) === null || _props$displayModalDa4 === void 0 ? void 0 : _props$displayModalDa4.modalHeaderTextStyle,
    modalHeaderIcon: true,
    modalDetailText: (_props$displayModalDa5 = props.displayModalData) === null || _props$displayModalDa5 === void 0 ? void 0 : _props$displayModalDa5.modalDetailText,
    modalDetailTextStyle: (_props$displayModalDa6 = props.displayModalData) === null || _props$displayModalDa6 === void 0 ? void 0 : _props$displayModalDa6.modalDetailTextStyle,
    positiveActionButtonTitle: (_props$displayModalDa7 = props.displayModalData) === null || _props$displayModalDa7 === void 0 ? void 0 : _props$displayModalDa7.positiveActionButtonTitle,
    negativeButtonActionTitle: (_props$displayModalDa8 = props.displayModalData) === null || _props$displayModalDa8 === void 0 ? void 0 : _props$displayModalDa8.negativeButtonActionTitle,
    positiveAction: (_props$displayModalDa9 = props.displayModalData) === null || _props$displayModalDa9 === void 0 ? void 0 : _props$displayModalDa9.positiveAction,
    negativeAvtion: (_props$displayModalDa10 = props.displayModalData) === null || _props$displayModalDa10 === void 0 ? void 0 : _props$displayModalDa10.negativeAction,
    crossIconAction: (_props$displayModalDa11 = props.displayModalData) === null || _props$displayModalDa11 === void 0 ? void 0 : _props$displayModalDa11.crossIconAction
  }));
};
var _default = exports.default = CurrentChangePasswordComponent;